import initVueApp from "@/core.js";
const component = require(`./../views/PageNotFound.vue`).default;
initVueApp(component);
